// Archivo: content/privacyPolicyContent.js
export const privacyPolicyContent = [
    {
      title: "Introduction",
      content: "We value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data."
    },
    {
      title: "Information We Collect",
      content: "We may collect personal information such as your name, email address, payment details, and any other information you provide during the registration or purchase process."
    },
    {
      title: "How We Use Your Information",
      content: "Your information is used to process transactions, provide customer support, improve our services, and send updates or promotional materials."
    },
    {
      title: "Cookies and Tracking Technologies",
      content: "We use cookies and similar technologies to enhance your experience, analyze site usage, and assist in our marketing efforts. You can manage your cookie preferences through your browser settings."
    },
    {
      title: "Sharing Your Information",
      content: "We do not sell or share your personal information with third parties, except as required by law or to provide essential services (e.g., payment processing)."
    },
    {
      title: "Data Retention",
      content: "We retain your information for as long as necessary to fulfill the purposes outlined in this policy or as required by law."
    },
    {
      title: "Your Rights",
      content: "You have the right to access, correct, or delete your personal data. You can also opt out of receiving promotional communications at any time."
    },
    {
      title: "Security",
      content: "We implement industry-standard security measures to protect your data from unauthorized access, alteration, or disclosure."
    },
    {
      title: "Changes to This Policy",
      content: "We may update this Privacy Policy periodically. We encourage you to review it regularly to stay informed about how we protect your information."
    },
    {
      title: "Contact Us",
      content: "If you have any questions or concerns about this Privacy Policy, please contact us at support@yourwebsite.com."
    }
  ];
  